import { defaultAppConfig, type AppConfig } from './baseConfig';
import { config as tenantConfig } from 'tenant/config';

const config: AppConfig = {
  ...defaultAppConfig,
  ...tenantConfig,
};

console.log(`[config] Loaded configuration for tenant: ${__TENANT__}`);
console.log('[config] Configuration:', config);

export default config;